import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Seo } from "./components/Seo";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import ServicePage from "@/pages/ServicePage";
import BusinessFinance from "@/pages/BusinessFinance";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import KnowledgeHub from "@/pages/KnowledgeHub";
import BlogPost from "@/pages/BlogPost";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";
import Brokers from "@/pages/Brokers";
import LegalPage from "@/pages/LegalPage";

function TrailingSlashRedirect() {
  const { pathname, search } = useLocation();
  if (pathname.length > 1 && pathname.endsWith("/")) return <Navigate to={pathname.replace(/\/+$/, "") + search} replace />;
  return null;
}

function NotFound() {
  return (
    <div data-testid="not-found-page" className="pt-40 pb-32 container-x mx-auto max-w-[1400px] text-center">
      <Seo title="Page not found" path="/404" noindex />
      <h1 className="text-4xl font-black">Page not found</h1>
      <p className="text-grey mt-4">The page you are looking for does not exist or has moved.</p>
      <a href="/" className="text-lime mt-6 inline-block">Back to homepage</a>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <FloatingCTA />
      <TrailingSlashRedirect />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<ServicePage />} />
          <Route path="/business-finance" element={<BusinessFinance />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/knowledge-hub" element={<KnowledgeHub />} />
          <Route path="/knowledge-hub/:slug" element={<BlogPost />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/brokers" element={<Brokers />} />
          <Route path="/privacy" element={<LegalPage />} />
          <Route path="/terms" element={<LegalPage />} />
          <Route path="/complaints" element={<LegalPage />} />
          <Route path="/cookies" element={<LegalPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#111", border: "1px solid rgba(216,255,0,0.3)", color: "#fff" } }} />
    </BrowserRouter>
  );
}

export default App;
